var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-quota-wrapper __form_border" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.addQuota.address")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse __ellipsis" }, [
          _vm._v(_vm._s(_vm.addr))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.addQuota.stakeDays")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse" }, [
          _vm._v(_vm._s(_vm.$t("walletQuota.aboutDays", { day: "30" })))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "__form_input_title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("stakingAmount")) +
                "\n                "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.amountErr,
                    expression: "amountErr"
                  }
                ],
                staticClass: "err"
              },
              [_vm._v(_vm._s(_vm.amountErr))]
            )
          ]),
          _vm._v(" "),
          _c(
            "vite-input",
            {
              staticClass: "pledge-input-wrapper",
              attrs: {
                type: "number",
                valid: _vm.testAmount,
                placeholder: _vm.$t("walletFullNode.addQuota.placeholder", {
                  min: _vm.minNum
                })
              },
              model: {
                value: _vm.amount,
                callback: function($$v) {
                  _vm.amount = $$v
                },
                expression: "amount"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "unit",
                  attrs: { slot: "after" },
                  slot: "after"
                },
                [_vm._v("dSLS")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.btnUnuse,
                expression: "!btnUnuse"
              }
            ],
            staticClass: "__form_btn __pointer",
            on: { click: _vm.validTx }
          },
          [_vm._v(_vm._s(_vm.$t("submitStaking")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.btnUnuse,
                expression: "btnUnuse"
              }
            ],
            staticClass: "__form_btn unuse"
          },
          [_vm._v(_vm._s(_vm.$t("submitStaking")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }